module.exports = __webpack_public_path__ + "static/Flame_ani-9199642c43883820741bf6334da036de.svg";